import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Category } from '../model/competitions/Category';
import { CompetitionService } from './competition.service';
import { AdministratorEntity } from '../model/administrator/AdministratorEntity';
import { AcademyAdministratorOperation } from '../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../model/administrator/AcademyAdministratorType';
import { Modalidad } from '../model/Modalidad';
import { QueryOptionDto } from '../model/QueryOptionDto';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private competitionService: CompetitionService) { }

  getAllCategories(modality?: Modalidad): Observable<any> {
    const options: QueryOptionDto | null = modality ? {
      options: {
        conditionals: [
          {
            conditionalConnector: 'AND',
            logicOperator: '=',
            evaluatedProperty: 'modality',
            parameterName: '@ModalidadSelected',
            parameterValue: modality,
          },
        ],
      },
    } : null;

    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.SELECT,
      payload: options,
      type: AcademyAdministratorType.CATEGORIES,
    };
    return this.competitionService.sendRequest(entity);
  }

  createCategory(category: Category): Observable<any> {
    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.CREATE,
      payload: category,
      type: AcademyAdministratorType.CATEGORIES,
    };
    return this.competitionService.sendRequest(entity);
  }

  updateCategory(category: Category): Observable<any> {
    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.UPDATE,
      payload: category,
      type: AcademyAdministratorType.CATEGORIES,
    };
    return this.competitionService.sendRequest(entity);
  }

  deleteCategory(category: Category): Observable<any> {
    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.DELETE,
      payload: category,
      type: AcademyAdministratorType.CATEGORIES,
    };
    return this.competitionService.sendRequest(entity);
  }
}